export enum LocalStorageKeys {
  // app state
  LAUNCH_COUNT = 'launchCount',
  NAVIGATED = 'navigated',
  LOCATION = 'location',
  DEVICEREF = 'deviceref',
  CITY = 'city',
  REGION = 'region',
  COUNTRY_CODE = 'countryCode',
  CONNECTION_BANDWIDTH = 'connectionBandwidthKbps',
  REMOVE_WATCH_LANG_ON_EXIT = 'removeWatchLangOnExit',

  // reuse strategy
  CLEAN_ROUTES = 'cleanRoutes', //used by reuse strategy to clean routes
  CLEAN_SEARCH = 'cleanSearch', //used by reuse strategy to clean SEARCH routes
  CHANGED_LANGUAGE = 'changedLanguage', // used by reuse strategy to clean routes and load all again
  TAB_CHANGED = 'tabChanged', // used by reuse strategy to clean tab cache
  // lang info
  LANG = 'lang',
  WATCH_LANG = 'watch-lang',
  DISPLAY_LANG = 'display-lang',
  // user info
  SELECTED_PROFILE = 'selectedProfile',
  SELECTED_PROFILE_ID = 'selectedProfileId',
  PROFILES = 'profiles',
  ACCOUNT_PROFILE = 'accountProfile',
  IS_PROFILE_SELECTED = 'isProfileSelected',
  //player preferences
  SUBTITLES_LANGUAGE = 'subtitlesLanguage',
  AUDIO_LANGUAGE = 'audioLanguage',
  SUBTITLES_PREFERENCE = 'subtitlesPreference',
  SUBTITLES_SIZE = 'subtitlesPreferredSize',
  SUBTITLES_THEME = 'subtitlesPreferredTheme',
  QUALITY_PREFERENCE = 'preferedQuality',
  AUTOPLAY_PREFERENCE = 'autoplayNext',

  // Profile preferences
  PROFILE_PREFERENCES = 'profilePreferences',

  //tokens
  //xAuthToken: Firstlight Token
  XAUTH_TOKEN = 'xAuthToken',
  XAUTH_TOKEN_EXP = 'xAuthTokenExp',
  ID_TOKEN = 'idToken',
  AUTHDATA = 'authData',
  AUTHDATA_TOKEN_EXP = 'authDataTokenExp',

  //auth0 tokens
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  REFRESH_TOKEN_EXP = 'refreshTokenExp',
  //content
  GENRE_KEYS = 'generekeys',
  STOREFRONTID = 'storefrontId',
  STOREFRONTNAME = 'storefrontName',

  // Login
  ACTIVATION_ATTEMPTS = 'activationAttempts',

  // splash state
  SPLASH_ENDED = 'splashEnded',
  SPLASH_CLOSE_AT_THE_END = 'closeSplashAtEnd',

  // user info
  CP_CUSTOMER_ID = 'cpCustomerID',
  SILENT_LOGIN = 'hasSilentLogin',
  FRESH_LAUNCH = 'freshLaunch',
}
